export const config = {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      columns: [],
      search:{}
    };
  },
  mounted() {
    // 监管模式设置默认值
    if (!this.$units.superviseShowVal()) {
      this.search.supplierType = '1';
    }
    let columns = [
      {
        title: '团队简称',
        key: 'groupName',
        align: 'center',
        minWidth: 120
      },
      {
        title: '产品名称',
        slot: 'productName',
        align: 'center',
        minWidth: 200
      },
      {
        title: '产品编码',
        key: 'productCode',
        align: 'center',
        minWidth: 100
      },
      {
        title: '保险公司',
        key: 'companyName',
        align: 'center',
        minWidth: 200,
        render(h, param) {
          let companyName = param.row.companyName;
          return <span>{companyName ? companyName : '-'}</span>;
        }
      },
    ];
    if (this.$units.showSupplier() && this.$units.pointAction('workbench_1')) {
      columns.push({
        title: '供应商',
        key: 'supplierName',
        align: 'center',
        minWidth: 200,
        render(h, param) {
          let supplierName = param.row.supplierName;
          return <span>{supplierName ? supplierName : '-'}</span>;
        }
      });
    }
    columns = columns.concat([
      {
        title: '服务费率',
        slot: 'fee',
        align: 'center',
        minWidth: 150,
        tooltip: true
      },
      {
        title: '操作',
        slot: 'action',
        align: 'center',
        fixed:'right',
        width: 160
      }
    ]);
    this.columns = columns;
  },
  methods: {}
};
